import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { Alert, Card, Tabs, Row, Col } from "antd"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
//i18n
import { withTranslation } from "react-i18next"
import Executors from "./executors"
import Engineers from "./engineers"
import PackageInstaller from "./PackageInstaller"

const BaseInfo = props => {
  const { t, openNotification } = props

  const [errorMessage, setErrorMessage] = useState(null)
  const [activeTab, setActiveTab] = useState("1")

  const handleChange = (key) => {
    setActiveTab(key)
  }

  //#region useEffect
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage(null)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [errorMessage])
  //#endregion

  const tabItems = [
    {
      key: "1",
      label: "لیست مجری",
      children: <Executors translate={t} openNotification={openNotification} />,
    },
    {
      key: "2",
      label: "لیست کارشناسان",
      children: <Engineers translate={t} openNotification={openNotification} />,
    },
    {
      key: "3",
      label: "لیست نصابان",
      children: <PackageInstaller translate={t} openNotification={openNotification} />,
    },
  ]

  const activeLabel = tabItems.find(item => item.key === activeTab)?.label

  return (
    <div>
      <MetaTags>
        <title> واحد گاز | اطلاعات پایه</title>
      </MetaTags>
        
        <Row gutter={[16, 16]}>
          <Col span={24}>
            {errorMessage && (
              <Alert 
                message={errorMessage} 
                type="error" 
                showIcon 
                closable 
                onClose={() => setErrorMessage(null)} 
                style={{ marginBottom: 16 }} 
              />
            )}
            {props.error && (
              <Alert 
                message={props.error} 
                type="error" 
                showIcon 
                style={{ marginBottom: 16 }} 
              />
            )}
            {props.success && (
              <Alert 
                message={props.success} 
                type="success" 
                showIcon 
                style={{ marginBottom: 16 }} 
              />
            )}
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card bordered={false} className="shadow-sm" bodyStyle={{ padding: '10px' }}>
              <Tabs
                activeKey={activeTab}
                onChange={handleChange}
                items={tabItems}
                type="card"
                size="large"
                className="custom-tabs"
                tabBarStyle={{ marginBottom: 16 }}
              />
            </Card>
          </Col>
        </Row>
    </div>
  )
}

BaseInfo.propTypes = {
  t: PropTypes.any,
  openNotification: PropTypes.func,
  error: PropTypes.string,
  success: PropTypes.string
}

export default withRouter(withTranslation()(BaseInfo))
